//TODO: add loading before boot
import Picker from "emoji-picker-react";
import React from "react";
//import { string } from "yargs";
import { auth, db, DB_NAME } from "../../firebase";
import styles from "./chat.module.css";
import sendEmail from "../../sendEmail/index";
import { Button, Grid, TextField } from "@material-ui/core";
import { LockOpen, SentimentVerySatisfiedOutlined } from "@material-ui/icons";
import { admin } from "../../constans/adminList";

export default class Chat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        displayName: null,
        email_id: null,
        uid: null,        
      },
      otherUserDisplayName: null,
      otherUserEmailId: null,
      otherUserUid: null,
      chats: [],
      content: "",
      error: null,
      matchId: null,
      validUser: false,
      showEmojiMenu: false,
      noAuth: true
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  onEmojiClick = (e, emojiObject) => {
    this.setState({
      showEmojiMenu: false,
      content: this.state.content + emojiObject.emoji,
    });
  };

  checkValidUser(matchId, userHash) {
    db.ref(`${DB_NAME}/${matchId}/users`).on("value", (snapshot) => {
      const validUsers = {};
      snapshot.forEach(function (item) {
        validUsers[item.key] = item.val();
      });
      if (userHash in validUsers) {
        this.setState({
          validUser: true,
          user: {
            displayName: validUsers[userHash].displayName,
            email_id: validUsers[userHash].email,
            uid: userHash,
          },
          otherUserDisplayName:
            validUsers[
              Object.keys(validUsers).filter((uid) => uid !== userHash)[0]
            ].displayName,
            
          otherUserEmailId: validUsers[
            Object.keys(validUsers).filter((uid) => uid !== userHash)[0]
          ].email,

          otherUserUid:
            Object.keys(validUsers).filter((uid) => uid !== userHash)[0],
        });
      }
    });
  }

  populateChat(matchId) {
    db.ref(`${DB_NAME}/${matchId}/history`).on("value", (snapshot) => {
      const chats = [];
      snapshot.forEach(function (item) {
        chats.push(item.val());
      });
      this.setState({ chats });
    });
  }

  scrollToBottom = () => {
    this.messagesEnd?.scrollIntoView({ behavior: "smooth" });
  }
  
  componentDidUpdate() {
    this.scrollToBottom();
  }

  async componentDidMount() {
    // console.log(auth.currentUser.uid)
    let noAuth = false
    await db.ref('config/noAuthRequired').on('value', (snapshot)=>{
      noAuth = snapshot.val()
    })
    // console.log('noAuth', noAuth)
    const matchId = this.props.match.params.matchId;
    const userHash = this.props.match.params.userHash;
    this.setState({ matchId, error: null });
    const plcholder = new URLSearchParams(this.props.location.search).get("placeholder")
    if(plcholder){
      this.setState({content:plcholder})
    }
    try {
      if(noAuth || (auth.currentUser?.uid === userHash) || admin.includes(auth.currentUser?.email?.toLowerCase())){
        this.populateChat(matchId);
        this.checkValidUser(matchId, userHash);
      }
    } catch (error) {
      this.setState({ error: error.message });
    }
  }

  handleChange = (event) => {
    this.setState({
      content: event.target.value,
    });
  }

  async handleSubmit(event) {
    event.preventDefault();
    this.setState({ error: null });
    if (this.state.content !== "") {
      try {

        let isFirstMsg;
        let last_msg;
        let cur_timestamp;
        let time_elapsed_seconds;
        let time_elapsed_minutes;

        console.log(this.state.chats);
        if(Array.isArray(this.state.chats) && this.state.chats.length){
          console.log("last msg exists");
          isFirstMsg= false;
        last_msg = this.state.chats[this.state.chats.length - 1];
        console.log(last_msg);
        console.log(last_msg.timestamp);
        cur_timestamp= new Date().getTime();
        console.log(cur_timestamp);
        time_elapsed_seconds=Math.floor((cur_timestamp - last_msg.timestamp)/1000);
        time_elapsed_minutes= Math.floor(time_elapsed_seconds/60);
        console.log("time elapsed: "+ time_elapsed_minutes);   
        }
        else {isFirstMsg=true;}
        
        
        await db.ref(`${DB_NAME}/${this.state.matchId}/history`).push({
          author: this.state.user,
          content: this.state.content,
          timestamp: Date.now(),
          uid: "random chat uid",
        });

        console.log(this.state.content);
        console.log(this.state.matchId);
        console.log(this.state.otherUserEmailId);
        console.log(this.state.otherUserUid);

        //TODO: send email notification

        let emailTarget= this.state.otherUserEmailId;
        let targetName= this.state.otherUserDisplayName;
        let targetUid= this.state.otherUserUid;
        let partner_Name= this.state.user.displayName;
        let message= this.state.content;
        let match_Id= this.state.matchId;
        let Domain= "https://chat.kopidate.com";

         //TODO: send email notification

    if (isFirstMsg) {
      console.log("first msg being sent");
      sendEmail(
      emailTarget,
      targetUid,
      targetName,
      partner_Name,
      message,
      match_Id,
      Domain
    ); }

    else{ 
      if ( (last_msg.author.uid !== this.state.user.uid) || (time_elapsed_minutes>=10) ) {
      console.log("last msg exists");
      sendEmail(
        emailTarget,
        targetUid,
        targetName,
        partner_Name,
        message,
        match_Id,
        Domain
      ); 

    } }

         this.setState({ content: "" });
         const plcholder = new URLSearchParams(this.props.location.search).get("placeholder")
         if(plcholder)
          this.props.history.replace(this.props.location.pathname)


      } catch (error) {
        this.setState({ error: error.message });
      }
    }
  }

  onEnterPress = (e) => {
    if (e.keyCode === 13 && e.shiftKey === false) {
      e.preventDefault();
      this.handleSubmit(e);
    }
  };

  timeConverter(UNIX_timestamp) {
    const time = new Date(UNIX_timestamp);
    return (
      time.toLocaleDateString("en-US") + " " + time.toLocaleTimeString("en-US")
    );
  }

  _handleToMail = () =>{
    const body = "Hey Kopi Artisan, I've finalized with my date and would like to reschedule it to: (date), (time). Thank you!"
    window.open(`mailto:hello@kopidate.com?subject=Kopi Date Rescheduling&body=${body}`, "_blank");
  }

  showChat() {
    return (
      this.state.chats.length !== 0 &&
      this.state.chats.map((chat) => {
        if (chat.author.uid === this.state.user.uid) {
          // is me
          return (
            <li key={chat.timestamp}>
              <div className={styles.myMessageDetails} >
                <span className={styles.messageTime}>
                  {this.timeConverter(chat.timestamp)}
                </span>
                &nbsp; &nbsp;
                <span className={styles.messageAuthor}>
                  {chat.author.displayName}
                </span>
                <div className={styles.circleBlue}></div>
              </div>
              <div className={styles.myMessageContent}>{chat.content}</div>
            </li>
          );
        } else {
          return (
            <li key={chat.timestamp}>
              <div className={styles.otherMessageDetails}>
                <div className={styles.circleGreen}></div>
                <span className={styles.messageAuthor}>
                  {chat.author.displayName}
                </span>
                &nbsp; &nbsp;
                <span className={styles.messageTime}>
                  {this.timeConverter(chat.timestamp)}
                </span>
              </div>
              <div className={styles.otherMessageContent}>{chat.content}</div>
            </li>
          );
        }
      })
    );
  }

  handleSignOut = () =>{
    auth.signOut()
    .then(()=>{
      window.location.reload()
    })
    .catch((error)=>{
      alert(error.message)
    })
  }

  render() {
    const { matchId, validUser, otherUserDisplayName } = this.state;
    const reschedule = this.props.match.params?.reschedule;
    // console.log('reschedule', this.props.match.params?.reschedule)
    // console.log('placeholder', new URLSearchParams(this.props.location.search).get("placeholder"))

    return (
      <div className={styles.container}>
        <Grid container justifyContent="center" style={{margin:'20px 0'}} >
            <Grid item lg={5} md={8} xs={12} >
              <Grid container justifyContent="space-between" alignItems='center' >
                <svg
                  style={{
                    width: "65px",
                    padding: "16px",
                  }}
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 90.89 46.33"
                >
                  <g>
                    <path d="M78.29 20h.56a3.76 3.76 0 002.74-.89 3.76 3.76 0 00.89-2.74V4.3a5.35 5.35 0 00-.35-1.5 2.32 2.32 0 00-.71-.93 3.76 3.76 0 00-2.57-.76h-.56V.58h12.6v.53h-.56a3.76 3.76 0 00-2.74.89 3.75 3.75 0 00-.88 2.75v11.64a3.72 3.72 0 00.89 2.74 3.75 3.75 0 002.73.89h.56v.56h-12.6zM37.87 19.88a5 5 0 01-1-.41 6.39 6.39 0 01-2.19-2 9.72 9.72 0 01-1.41-3.12 15.69 15.69 0 01-.48-4 17 17 0 01.3-3.29A11.19 11.19 0 0134 4.29a8.36 8.36 0 011.5-2.14A5.14 5.14 0 0137.44.87a3.66 3.66 0 01.43-.15V0a12.43 12.43 0 00-4.25 1.31 11.55 11.55 0 00-4.34 3.81 9.21 9.21 0 00-1.61 5.19 9 9 0 00.93 4 10.48 10.48 0 002.62 3.36 12.14 12.14 0 003.87 2.23 13 13 0 002.78.66zM50.93 6.66a10.9 10.9 0 00-2.23-3.25A11.55 11.55 0 0044.65.79 13.74 13.74 0 0041.51 0v.69a5.49 5.49 0 011.29.61 6.77 6.77 0 012.07 2.06 9.68 9.68 0 011.32 3 14.49 14.49 0 01.46 3.75 15.27 15.27 0 01-.84 5.34 7.63 7.63 0 01-2.4 3.55 5.78 5.78 0 01-1.9 1v.67a12.74 12.74 0 004.27-1.28 11.16 11.16 0 004.34-3.77 9.11 9.11 0 00.81-8.87zM75.41 2.88a6.85 6.85 0 00-3.61-1.8c-.44-.09-1-.18-1.66-.25S68.72.7 67.88.65 66.43.59 65.79.58v.53H66a11.87 11.87 0 012.34.19 5 5 0 011.66.6q2 1.17 2 4.16a4.73 4.73 0 01-1.42 3.79 6.55 6.55 0 01-4.38 1.22h-4V.58h-8.58v.53h.67c2.42 0 3.64 1.21 3.64 3.64v11.64c0 2.44-1.22 3.66-3.64 3.66h-.7v.53h13.2v-.53h-1q-3.65 0-3.64-3.66v-4.76h5.48a17.71 17.71 0 003.81-.37 9.48 9.48 0 002.86-1.08 5 5 0 001.76-1.74 4.5 4.5 0 00.61-2.35 4.41 4.41 0 00-1.26-3.21zM85.45 27.59a5.34 5.34 0 012 1.53A9 9 0 0188.63 31a23 23 0 011.05 3h.43v-7.67h-9.25v.53h.31a11.1 11.1 0 014.28.73zM90.11 38.09a23.25 23.25 0 01-.93 2.75 8.05 8.05 0 01-2.18 3 7.8 7.8 0 01-1.75 1.13 8.12 8.12 0 01-2.09.65 15 15 0 01-2.63.21h-3.29v-8.98h.83a4.44 4.44 0 013.66 1.59 6.38 6.38 0 01.75 1.17 6.9 6.9 0 01.52 1.53c.16.62.3 1.29.41 2h.5V30h-.5a13 13 0 01-.31 1.82 7.61 7.61 0 01-1.06 2.49 4.34 4.34 0 01-3.75 2h-1.05v-9.98h-8.4v.53h.55a3.75 3.75 0 012.75.88 3.77 3.77 0 01.86 2.75v11.64c0 2.44-1.21 3.67-3.63 3.67h-.55v.53h21.82v-8.24zM50.85 27.28v-1h-6v10.2h.5a21.31 21.31 0 01.38-2.35 12.4 12.4 0 011.67-3.92 7.3 7.3 0 013.45-2.93zM54.49 26.33V42.13q0 3.65-3.63 3.64h-3v.56h17.48v-.56h-3c-2.42 0-3.62-1.21-3.62-3.64V26.86h1A6.93 6.93 0 0165.55 30a13.21 13.21 0 012.29 6.55h.46V26.33zM30.4 45.35a2.46 2.46 0 01-.95-1 2.65 2.65 0 01-.37-1.3 4 4 0 01.32-1.54l.6-1.45h5.3l-.24-.53h-4.77l2.37-5.39-.29-.62-3 6.79a11.58 11.58 0 01-3 4.43 5.14 5.14 0 01-1.17.71 5.27 5.27 0 01-1.41.32v.56H32v-.56a4.81 4.81 0 01-.88-.11 2.43 2.43 0 01-.72-.31z" />
                    <path d="M47.67 45.77a3.8 3.8 0 01-1.42-.24 2.92 2.92 0 01-1.08-.76 5.82 5.82 0 01-.87-1.35l-8-17.49h-.53l-1.79 4L39 41.15l.14.31c.45 1 .75 1.64.88 2a3 3 0 01.21 1 1 1 0 01-.52 1 3.46 3.46 0 01-1.66.31h-1.46v.56H48.2v-.56zM9.93 19.12A3.68 3.68 0 019 16.39V4.75A3.75 3.75 0 019.93 2a3.74 3.74 0 012.72-.91h.59V.58H.58v.5h.59A3.75 3.75 0 013.92 2a3.75 3.75 0 01.91 2.76v11.63a3.67 3.67 0 01-.91 2.73 3.75 3.75 0 01-2.75.9H.61v.56h12.63V20h-.59a3.73 3.73 0 01-2.72-.88zM27.61 1.08h.29v-.5H16.2v.5h.47a4.25 4.25 0 012.49.64 2 2 0 01.92 1.71 2.09 2.09 0 01-.32 1.15 6.71 6.71 0 01-1.27 1.28l-4.9 3.93.15.53 4.58 7.07a7.26 7.26 0 01.49.85 1.21 1.21 0 01.12.49q0 1.27-2.73 1.27h-.64v.56H27.9V20h-.38a4.79 4.79 0 01-2.58-.69 7.28 7.28 0 01-2.11-2.24l-6-9.27 3.93-3.13q4.43-3.6 6.85-3.59zM67 26.33h2.45v.55H67zM0 26.86h.73a3.75 3.75 0 012.75.88 3.08 3.08 0 01.81 1.79v11.7c0 1.19.11 2.36-.69 3.35a3.65 3.65 0 01-2.87 1.19H0v.56h8.59v-20H0zM25.1 32.88a10.46 10.46 0 00-2.3-3.26 10.05 10.05 0 00-4.06-2.48 17.78 17.78 0 00-5.65-.81h-1v.53a17.85 17.85 0 012.74.18 7.57 7.57 0 012 .61 5.84 5.84 0 011.59 1.11 7.51 7.51 0 011.4 2 10.64 10.64 0 01.85 2.59 15.43 15.43 0 01.33 3.07q0 5-2.37 7.44A5 5 0 0117.07 45a7 7 0 01-2 .61 17 17 0 01-2.79.19h-.23v.56h2a15.39 15.39 0 004.74-.71 11.76 11.76 0 003.78-2A9 9 0 0025 40.51a8.64 8.64 0 00.88-3.89 9.13 9.13 0 00-.78-3.74z" />
                  </g>
                </svg>

                <div className={styles.loggedInAs}>
                  <div>
                    Logged in as: <strong>{this.state.user.displayName || auth.currentUser?.displayName[0]}</strong>
                  </div>
                  <Button 
                    onClick={this.handleSignOut} 
                    startIcon={<LockOpen/>} 
                    variant="outlined" 
                    className={styles.signoutBtn}
                    size="small" >
                    Signout
                  </Button>
                </div>
              </Grid>
            </Grid>
          </Grid>

        {!matchId || !validUser ?
        <div className={styles.noMatchIdContainer}>
          <strong>No valid chat id</strong>
        </div>
        :
          <Grid container justifyContent="center" >
            <Grid item lg={5} md={8} xs={12} >
              <div className={styles.chat}>
                <div className={styles.chatHeader}>
                  Chatting with
                  <strong style={{ textTransform: "capitalize" }}>
                    {" "}
                    {otherUserDisplayName}
                  </strong>
                </div>
                <div className={styles.chatHistory}>
                  {reschedule &&
                    <div className={styles.firstSystemMessage} >
                      Note: Kindly use this chat to reschedule the date 
                      <strong> within 2 weeks</strong> from the proposed date. 
                      Rescheduling must be finalised in <strong>4 days time</strong>. <br/> <br/>To provide the best experience for everyone, kindly keep the chat <strong>anonymous</strong> by not revealing any personal information (i.e. name, contact details).
                    </div>
                  }
                  {this.showChat()}
                  {reschedule &&
                    <Button 
                      variant="outlined" 
                      className={styles.confirmBtn}
                      onClick={this._handleToMail}
                      size="small">
                      CONFIRM TIMING
                    </Button>
                  }
                  <div style={{ float:"left", clear: "both" }}
                      ref={(el) => { this.messagesEnd = el; }}>
                  </div>
                </div>

                <form onSubmit={this.handleSubmit}>
                  <TextField 
                    fullWidth 
                    variant="outlined" 
                    multiline 
                    onChange={this.handleChange}
                    value={this.state.content}
                    onKeyDown={(e) => this.onEnterPress(e)}
                    style={{width:'90%', alignSelf:'center', backgroundColor:'#fff' }}
                  />
                  {this.state.error ? (
                    <div className={styles.error}>{this.state.error}</div>
                  ) : null}

                  <div className={styles.sendAndEmojiContainer}>
                    <div className={styles.emojiPicker}>
                      {this.state.showEmojiMenu && (
                        <Picker onEmojiClick={this.onEmojiClick} />
                      )}
                    </div>
                    <div
                      onClick={() =>
                        this.setState({
                          showEmojiMenu: true,
                        })
                      }
                      style={{ cursor: "pointer" }}
                    >
                      <SentimentVerySatisfiedOutlined style={{color:'#7ea4d7'}} />
                    </div>

                    <button type="submit">Send</button>
                  </div>
                </form>
              </div>
            </Grid>
          </Grid>
  }
      </div>
    );
  }
}
